module.exports = __webpack_public_path__ + "img/09edaf7.png";